export default __webpack_public_path__ + "static/media/imchi.3a3d26df.mpeg";